import type { ComputedRef } from 'vue'
import type { AppBadgeColor } from '../../app-badge'
import type { BadgeSurveyStatusProps } from '../types/interfaces'

import { SurveyStatus } from '@brighterly/lib-core-types/survey/enums'

import { useListsStore } from '@shared/model'

import { useBadgeFromStatus } from '../../app-badge'

interface BadgeSurveyStatusOptions {
  props: BadgeSurveyStatusProps
}

interface BadgeSurveyStatusReturn {
  color: ComputedRef<AppBadgeColor>
  text: ComputedRef<string>
}

/** The legacy markers: plain black for sent and overdue (the kit's neutral is slate), dark amber for partly filled. */
const SURVEY_STATUS_COLORS: Record<SurveyStatus, AppBadgeColor> = {
  [SurveyStatus.New]: 'slate',
  [SurveyStatus.Unfinished]: 'amber',
  [SurveyStatus.Finished]: 'emerald',
  [SurveyStatus.Overdue]: 'slate',
}

export const useBadgeSurveyStatus = ({ props }: BadgeSurveyStatusOptions): BadgeSurveyStatusReturn => {
  const listsStore = useListsStore()

  return useBadgeFromStatus<SurveyStatus>({
    status: () => props.status,
    colors: SURVEY_STATUS_COLORS,
    labels: () => listsStore.getLists?.surveys?.status,
  })
}
